<template>
  <div
    v-if="$slots.default"
    :class="containerClasses"
    role="note"
    :data-cy="dataCy"
  >
    <component :is="iconComponent" class="h-4 w-4 flex-shrink-0 mt-0.5" />
    <div class="text-sm leading-snug min-w-0 flex-1">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import InfoIcon from "@/images/info.svg?component";
import WarningIcon from "@/images/Warning.svg?component";

const props = withDefaults(
  defineProps<{
    tone?: "info" | "warn" | "danger";
    dataCy?: string;
  }>(),
  {
    tone: "warn",
    dataCy: undefined
  }
);

const containerClasses = computed(() => {
  // whitespace-normal cancels any inherited `nowrap` (Bootstrap injects it
  // on several ancestor classes) so warning copy wraps inside narrow
  // columns instead of overflowing.
  const base =
    "flex items-start gap-2 rounded-md border px-3 py-2 whitespace-normal";
  if (props.tone === "info") {
    return `${base} bg-blue-50 border-blue-200 text-blue-900`;
  }
  if (props.tone === "danger") {
    return `${base} bg-red-50 border-red-200 text-red-900`;
  }
  return `${base} bg-amber-50 border-amber-200 text-amber-900`;
});

const iconComponent = computed(() =>
  props.tone === "info" ? InfoIcon : WarningIcon
);
</script>
